import {Component, OnInit}        from '@angular/core';
declare var $: any;
import {UsuariosService} from './usuario.service';
import {Sucursal} from '../sucursal/sucursal';
import {Usuario} from './usuario';
import {SucursalService} from '../sucursal/sucursal.service';
import {Empresa} from '../empresa/empresa';
import {Rol} from '../rol/rol';
import {RolService} from '../rol/rol.service';
import {EmpresaService} from '../empresa/empresa.service';
import {PermisoService} from '../permiso/permiso.service';
import {ActivatedRoute, Router} from '@angular/router';
import {LoginService} from '../login/login.service';
import 'rxjs/Rx';

import myGlobals = require('../config');

@Component({
    selector: 'usuario',
    template: require('../../app/usuarios/usuario.component.html'),
    styles: [require('../../app/usuarios/usuario.component.css')]
})
export class UsuariosComponent implements OnInit {
    empresas: Empresa;
    empresa2: Empresa;
    usuario: Usuario;
    sucursales: Sucursal[];
    sucursal: Sucursal;
    modificoSucursal;
    idSeleccionado;
    active: any;
    active2: any;
    deshabilitar: boolean;
    permisos: any;
    roles: Rol[];
    rol: Rol;
    passRequired: boolean;
    administrador: string;
    pruebaSMS: boolean;
    probando: boolean;
    saving: boolean;

    constructor(private usuarioService: UsuariosService,
                private sucursalService: SucursalService,
                private empresaService: EmpresaService,
                private loginService: LoginService,
                private permisoService: PermisoService,
                private rolService: RolService,
                private router: Router) {
    }

    ngOnInit() {
        window.scrollTo(0, 0);

        //Perdir permisos
        this.permisos = new Map();
        this.permisoService.getPermiso("usuarios").subscribe(permisos => {
            for (let permiso of permisos.tipoPermiso) {
                this.permisos.set(permiso.descripcion, true);
            }
            //Si no tiene permiso para ver redirijo
            if (!this.permisos.get("read"))
                this.router.navigate(['/home']);
        });
        //Inicializar tabla
        $("#grid-data").bootgrid({
            ajax: true,
            url: myGlobals.default.BASE_URL + "/usuarios/usuariosTable",
            selection: true,
            multiSelect: false,
            rowSelect: true,
            formatters: {
                "empresa": function (column, row) {
                    return row.sucursales[0] != undefined ? row.sucursales[0].empresa.descripcion : "Usuario Ilimitado";
                },
                "estado": function (column, row) {
                    return row.estado == true ? "Activo" : "<span class=\"label label-danger\">Inactivo</span>"
                },
                "rol": function (column, row) {
                    return row.rol != undefined ? row.rol.descripcion : "Sin Rol";
                },
            },
            ajaxSettings: {
                headers: {
                    "Authorization": this.loginService.getToken()
                },
                method: "GET"
            }
        });

        $("#alertSeleccion").hide();

        //Inicializar banderas para resetear forms
        this.active = true;
        this.active2 = true;
        //  Cargar empresas
        this.empresaService.getEmpresas()
            .subscribe(empresas => {
                this.empresas = empresas;
            });
        this.rolService.getRoles()
            .subscribe(roles => {
                this.roles = roles;
                //Buscar admin
                this.roles.forEach(function (rol) {
                    if (rol.descripcion == "Administrador") {
                        this.administrador = rol._id;
                    }

                }.bind(this))
            });
        //Inicializar sucursal
        this.sucursal = new Sucursal();
        this.usuario = new Usuario();
        this.usuario.sucursales = [];
        //Inicializar bandera deshabilitar
        this.deshabilitar = false;
        //Inicializar pruebaSMS
        this.pruebaSMS = false;
        this.probando = false;
        this.saving = false;


    }

    ngOnDestroy() {
    }

    agregar() {
        //Cerrar alert
        $("#alertUsuario").hide();
        //Inicializo variables
        this.usuario = new Usuario();
        this.sucursal = new Sucursal();
        this.deshabilitar = false;
        $("#pass").show();
        this.passRequired = true;
        //Mostrar modal
        $("#modalUsuario").modal("show");
        //Reseteo form1 para eliminar errores
        this.active = false;
        setTimeout(() => this.active = true, 0);
        //Reseteo form2 para eliminar errores
        setTimeout(() => this.active2 = false, 0);
        setTimeout(() => this.active2 = true, 0);
        this.pruebaSMS = false;
    }

    modificar() {
        $("#pass").hide();
        this.passRequired = false;
        //Obtener id seleccionado
        this.idSeleccionado = $("#grid-data").bootgrid("getSelectedRows")[0];
        //Si no hay nada seleccionado mostrar alert
        if (this.idSeleccionado == undefined) {
            $("#alertSeleccion").show();
        }
        else {
            if (this.idSeleccionado != "0") {
                //Cerrar alert
                $("#alertSeleccion").hide();
                //Busco usuario
                this.usuarioService
                    .getUsuario(this.idSeleccionado)
                    .subscribe(user => {
                        this.usuario = user;
                    });
                //Seteo bandera para deshabilitar
                this.deshabilitar = false;
                //Ocultar modal
                $("#modalUsuario").modal("show");
                this.pruebaSMS = false;
            }
        }
    }

    eliminar() {
        //Obtener id seleccionado
        this.idSeleccionado = $("#grid-data").bootgrid("getSelectedRows")[0];
        //Si no hay nada seleccionado mostrar alert
        if (this.idSeleccionado == undefined) {
            $("#alertSeleccion").show();
        }
        else {
            if (this.idSeleccionado != "0") {
                //Cerrar alert
                $("#alertSeleccion").hide();
                //Busco usuario
                this.usuarioService
                    .getUsuario(this.idSeleccionado)
                    .subscribe(usuario => {
                        this.usuarioService.delete(usuario).subscribe(() => $("#grid-data").bootgrid("reload"));
                    });
            }
        }
    }

    ver() {
        //Obtener id seleccionado
        this.idSeleccionado = $("#grid-data").bootgrid("getSelectedRows")[0];
        //Si no hay nada seleccionado mostrar alert
        if (this.idSeleccionado == undefined) {
            $("#alertSeleccion").show();
        }
        else {
            if (this.idSeleccionado != "0") {
                //Cerrar alert
                $("#alertSeleccion").hide();
                //Busco sucursal
                this.usuarioService
                    .getUsuario(this.idSeleccionado)
                    .subscribe(usuario => {
                        this.usuario = usuario;
                    });
                this.deshabilitar = true;
                //Muestro modal
                $("#modalUsuario").modal("show");
                this.pruebaSMS = false;
            }
        }
    }

    save() {
        if (this.usuario.rol == this.administrador) {
            this.usuario.sucursales = [];
        }
        this.saving = true;
        this.usuarioService
            .save(this.usuario)
            .subscribe(
                (usuario) => {
                    this.usuario = usuario;
                    //Inicializo variables
                    this.saving = false;
                    this.usuario = new Usuario();
                    //Ocultar modal
                    $("#modalUsuario").modal("hide");
                    //Reseteo formUsuario para eliminar errores
                    this.active = false;
                    setTimeout(() => this.active = true, 0);
                    //Recargo tabla
                    $("#grid-data").bootgrid("reload")
                },
                (error) => {
                    this.saving = false;
                })
    }

    agregarSucursal(sucursalId) {
        if (!this.modificoSucursal && sucursalId != "") {
            //Inicializar arreglo
            if (this.usuario.sucursales == undefined)
                this.usuario.sucursales = [];
            //Agregar Sucursal
            this.sucursalService.getSucursal(sucursalId)
                .subscribe(
                    sucursal => {
                        if (this.usuario.sucursales.filter(function (e) {
                                return e._id == sucursal._id
                            }.bind(this)).length == 0) {
                            this.sucursal = sucursal;
                            this.usuario.sucursales.push(this.sucursal);
                            //Limpiar Sucursal
                            this.sucursal = new Sucursal();
                        }
                        else
                            alert("La sucursal seleccionada ya esta habilitada para el usuario.");
                    });
        }
        else {
            //Limpiar sucursal
            this.sucursal = new Sucursal();
            //Seteo bandera
            this.modificoSucursal = false;
        }
        //Reseteo formSucursal para eliminar errores
        setTimeout(() => this.active2 = false, 0);
        setTimeout(() => this.active2 = true, 0);
    }


    eliminarSucursal(index) {
        //Eliminar sucursal de la lista
        this.usuario.sucursales.splice(index, 1);
    }

    cargarSucursales(idEmpresa) {
        if (idEmpresa != "") {
            this.sucursalService.getSucursalByEmpresa(idEmpresa)
                .subscribe(sucursales => {
                    this.sucursales = sucursales;
                });
        }
    }

    hideAlert() {
        $("#alertSeleccion").hide();
    }

    probarCelular() {
        this.pruebaSMS = false;
        this.probando = true;
        if (this.usuario.celular != "") {
            console.log("OK");
            this.usuarioService.probarCelular(this.usuario.celular)
                .subscribe(
                    (result) => {
                            console.log("OK");
                            this.pruebaSMS = true;
                            this.probando = false;
                            $(document).on('hidden.bs.modal', '.modal', function () {
                                $('.modal:visible').length && $(document.body).addClass('modal-open');
                            });
                        },
                    (error) => {
                            this.probando = false;
                        }
                )

        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/usuarios/usuario.component.ts